<template>
  <!-- <b-row>
    <b-col> -->
  <!-- {{ selectedfile }} -->
  <VueFileAgent class=" mt-2" :class="file_container_class + ' ' + file_container_border_class" 
    ref="vueFileAgent"
    :multiple="multiple" :linkable="true" :deletable="true" :meta="true" :resumable="true" :accept="accept"
    :averageColor="false" 
    @select="filesSelected($event)" 
    @beforedelete="onBeforeDelete($event)"
    @delete="fileDeleted($event)" v-model="selectedfile">
    <template v-slot:before-inner>
      <b-row class="mb-3">
        <b-col :class="{
          'px-1': with_border == 'true',
        }">
          <p class=" my-2 float-left w-auto" :class="label_class" v-html="label">
          </p>
          <b-button :variant="button_variant" class="btn-bumblebee float-right w-auto" :class="btn_class">
            <font-awesome-icon icon="fa-solid fa-upload" />
            {{ button_text }}
          </b-button>
        </b-col>
      </b-row>
    </template>
    <template v-slot:file-preview-new>
      <div key="new"></div>
    </template>
  </VueFileAgent>
  <!-- </b-col>
  </b-row> -->
</template>


<script>
export default {
  name: "InputFile",
  components: {},
  props: [
    "label",
    "button_text",
    "multiple",
    "accept",
    "selectedfile_prop",
    "with_border",
  ],
  props: {
    label: {
      type: String
    },
    button_text: {
      type: String
    },
    multiple: {
      type: Boolean
    },
    accept: {
      type: String
    },
    selectedfile_prop: {
      type: Array
    },
    with_border: {
      type: Boolean,
      default: false
    },

    file_container_border_class: {
      type: String,
      default: ''
    },

    file_container_class: {
      type: String,
      default: 'file-preview-container-garden-help'
    },
    label_class: {
      type: String,
      default: "form-label-garden-help"
    },
    button_variant: {
      type: String,
      default: "garden-help-primary-light"
    },
    btn_class: {
      type: String,
      default: "btn-garden-help"
    },

  },

  data() {
    return {
      selectedfile: [],
      selectedfileForUpload: [], // maintain an upload queue
    };
  },
  beforeMount() { },
  mounted() {
    // console.log(this.selectedfile_prop)
    // let temp= this
    // setTimeout(function () {
    //   temp.selectedfile = temp.selectedfile_prop;
    //   temp.selectedfileForUpload = temp.selectedfile_prop;
    // }, 2000);
    // console.log(this.selectedfile_prop[0].src());
  },
  watch:{
    _selectedfile_prop(newval,oldval){
      // console.log("mmmmm")
      // console.log(newval)
      // console.log(oldval)
      if(newval==null){
        this.selectedfile =[]
        this.selectedfileForUpload =[]
        this.$refs.vueFileAgent.value = null;
        

      }
    }
  },
  computed: {
    _selectedfile_prop: {
      get() {
        return this.selectedfile_prop;
      },
      set(value) {
        this.$emit("update:selectedfile_prop",value);
      },
    }
  },
  methods: {
    filesSelected(selectedfile) {
      // console.log("filesSelected", selectedfile);
      // console.log(selectedfile[0].file);
      // console.log(selectedfile[0].src());

      var validFileRecords = [];
      // for (var i = 0; i < selectedfile.length; i++) {
      //   if (!selectedfile[i].error) {
      //     validFileRecords.push(selectedfile[i]);
      //   }
      // }
      for (var i = 0; i < this.selectedfile.length; i++) {
        if (!this.selectedfile[i].error) {
          validFileRecords.push(this.selectedfile[i]);
        }
      }
      // console.log("filesSelected", this.selectedfile, validFileRecords);
      // this.selectedfileForUpload =
      //   this.selectedfileForUpload.concat(validFileRecords);

      this.selectedfileForUpload = validFileRecords;
      // console.log(this.selectedfileForUpload)

      // console.log(this.selectedfile_prop)
      this.$emit("update:selectedfile_prop", this.selectedfileForUpload);
      // console.log(this.selectedfileForUpload)
      // console.log(this.selectedfile_prop)
      // console.log(this.selectedfileForUpload)

    },

    onBeforeDelete(fileRecord) {
      // console.log("in before delete");
      // console.log(fileRecord);
      var i = this.selectedfileForUpload.indexOf(fileRecord);
      // console.log(i);
      if (i !== -1) {
        this.selectedfileForUpload.splice(i, 1);
        var k = this.selectedfile.indexOf(fileRecord);
        if (k !== -1) this.selectedfile.splice(k, 1);
      } else {
        // if (confirm("Are you sure you want to delete?")) {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        // }
      }
      // console.log(this.selectedfileForUpload)
      // console.log(this.selectedfile_prop)
      this.$emit("update:selectedfile_prop", this.selectedfileForUpload);
      // console.log(this.selectedfile_prop)
    },
    fileDeleted(fileRecord) {
      // console.log("file deleted");
      // console.log(fileRecord);
      var i = this.selectedfileForUpload.indexOf(fileRecord);
      // console.log(i);
      if (i !== -1) {
        this.selectedfileForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
      // console.log(this.selectedfile);
      // console.log(this.selectedfileForUpload);
      this.$emit("update:selectedfile_prop", this.selectedfileForUpload);
    },

    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Inputs/InputFile.vue